import React, { useEffect, useState, useRef } from 'react';
import LoadingSpinner from 'src/common/components/loading-spinner';
import LoadingSpinnerLight from 'src/common/components/loading-spinner/light';
import JourneyListbox from 'src/common/form/JourneyListbox';
import { NeueListbox } from 'src/common/form/NeueListbox';
import { CameraStrongIcon, DeleteRegularIcon, MicStrongIcon } from 'src/monet/icons';
import { ControlPanelActionButton } from '../components/control-panel/action-button';
import { NeueJourneyButton } from '../components/neue-button/journey';
import { NeueToggleComponent } from '../components/toggle/component';
import { useBlockActions } from '../helpers/actions/use-block-actions.hook';
import { Block } from '../types';
import { useRecordingStore } from './store';
import { useEditorStore } from '../editor-store';
import VideoCameraStrongIcon from 'src/monet/icons/VideoCameraStrongIcon';
import { NeueLoadingSpinner } from '../components/loading/spinner';

type Props = {
  block: Block;
  onDeleteBlock: () => void;
};

export const AddRecordingControlPanelContent = ({ block, onDeleteBlock }: Props) => {
  const {
    videoInputs,
    audioInputs,
    selectedVideoInput,
    selectedAudioInput,
    startRecordingCamera,
    handleDeviceChange,
    recording,
  } = useRecordingStore((state: any) => ({
    videoInputs: state.videoInputs,
    audioInputs: state.audioInputs,
    selectedVideoInput: state.selectedVideoInput,
    selectedAudioInput: state.selectedAudioInput,
    startRecordingCamera: state.startRecordingCamera,
    handleDeviceChange: state.handleDeviceChange,
    recording: state.recording,
  }));

  const renderSelectedValue = (input: MediaDeviceInfo) => {
    const logo =
      input.kind === 'videoinput' ? (
        <VideoCameraStrongIcon className='flex-shrink-0' />
      ) : (
        <MicStrongIcon className='flex-shrink-0' />
      );
    return (
      <div className='flex items-center space-x-2 truncte'>
        {logo}
        <span className='truncate'>{input.label}</span>
      </div>
    );
  };

  if (recording) return null;

  if (videoInputs.length === 0 || audioInputs.length === 0) return <NeueLoadingSpinner className='mx-auto' size='16' theme='journey' />;

  return (
    <div className='flex flex-col space-y-4'>
      <div className='flex flex-col space-y-2'>
        <NeueListbox
          containerClassName='w-full min-w-0'
          options={videoInputs}
          defaultLabel='Select Video Source'
          renderValue={(input: MediaDeviceInfo) => input.label}
          renderSelectedValue={renderSelectedValue}
          renderKey={(input: MediaDeviceInfo) => input.deviceId}
          selected={selectedVideoInput}
          onChange={(value: MediaDeviceInfo) => handleDeviceChange(value)}
        />
        <NeueListbox
          containerClassName='w-full min-w-0'
          options={audioInputs}
          defaultLabel='Select Audio Source'
          renderValue={(input: MediaDeviceInfo) => input.label}
          renderSelectedValue={renderSelectedValue}
          renderKey={(input: MediaDeviceInfo) => input.deviceId}
          selected={selectedAudioInput}
          onChange={(value: MediaDeviceInfo) => handleDeviceChange(value)}
        />
      </div>
      <NeueJourneyButton type='button' variant='secondary' onClick={startRecordingCamera}>
        <div className='flex items-center space-x-2'>
          <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <circle cx='8' cy='8' r='8' fill='#FF5158' />
          </svg>
          <span className='text-neue-journey-fg'>Start recording</span>
        </div>
      </NeueJourneyButton>
      <ControlPanelActionButton label='Delete block' iconComponent={DeleteRegularIcon} onClick={onDeleteBlock} />
    </div>
  );
};
